<template>
  <div class="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">

    <template v-if="page">

      <h1 class="text-3xl font-bold text-center">{{ page.name }}</h1>
      <div class="content block my-8"  v-html="page.data">
      </div>
    </template>
    <template v-else-if="state === STATE.loading">
        <span class="inline items-center justify-center inline-flex w-full">
          <svg class="animate-spin h-8 w-8 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="animate-pulse text-lg font-bold ml-2">Loading...</span>
        </span>
    </template>
    <template v-else-if="state === STATE.error">
      <h1 class="text-3xl font-bold text-center" >
        {{ error }} data not found
      </h1>
    </template>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import {pageById} from "@/firebase";
import {useSwrCache, STATE} from "@/composables/swr-cache";
export default {
  name: "PageDetail",
  setup() {
    const route = useRoute()
    const {
      data: page,
      error,
      state,
    } = useSwrCache(`${route.params.id}`, pageById);

    return {
      STATE,
      error,
      state,
      page,
    };
  }
}
</script>
